import { render, staticRenderFns } from "./PBRMappingShow.vue?vue&type=template&id=72c5c3a8&"
import script from "./PBRMappingShow.vue?vue&type=script&lang=js&"
export * from "./PBRMappingShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports